/** Webhook POST body `event` values. */
export const WEBHOOK_EVENT = {
  MESSAGE_CREATED: "message.created",
  MESSAGE_UPDATED: "message.updated",
  MESSAGE_DELETED: "message.deleted",
  CALL_STARTED: "call.started",
  CALL_ENDED: "call.ended",
  CALL_MISSED: "call.missed",
} as const;

export type WebhookEvent = (typeof WEBHOOK_EVENT)[keyof typeof WEBHOOK_EVENT];

export interface WebhookPayload {
  event: WebhookEvent;
  roomId: string;
  message?: unknown;
  call?: unknown;
}
